<template>
  <v-content>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="titulos">Horario de Recursos</h1>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            :pagination.sync="pagination"
            class="table-margin elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.ResourceType.name }}</td>
              <td class="justify-center px-0">
                <v-btn icon class="mx-0" @click="modificarHorarios(props.item.id, props.item.name)">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </div>
          <v-snackbar
            :timeout=6000
            :color="color"
            :multi-line="'multi-line'"
            v-model="snackbar">
            <v-icon dark>error_outline</v-icon>
            {{ error }}
            <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable */
  import Shared from '@/services/Shared';
  import moment from 'moment'

  export default {
    data() {
      return {
        items: [],
        headers: [
          {text: 'Recurso', value: 'name'},
          {text: 'Tipo', value: 'resource_type'},
          {text: 'Acciones', value: 'actions', sortable: false, align: 'center'}
        ],
        dialog: false,
        options: {},
        pagination: {
          rowsPerPage: 10
        },
        error: null,
        snackbar: false,
        color: '',
      }
    },
    created() {
      this.resources()
    },
    methods: {
      async resources() {
        try {
          const response = await Shared.resources()
          this.items = response.data.data
        } catch (err) {
          console.log(err)
        }
      },
      navigateTo(route) {
        this.$router.push(route)
      },
      modificarHorarios(id, name) {
        this.$router.push({name: "editresourcesschedule", params: {id, name}})
      },
      async deleteResource(id) {
        try {
          const response = await Shared.deleteResource({
            id: id
          })
          this.error = response.data.msg
          this.snackbar = true
          this.color = 'success'
          this.resources()
        } catch (err) {
          this.error = err.response.data.msg
          this.snackbar = true
          this.color = 'error'
        }
      },
    },
    computed: {
      pages() {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      }
    }
  };
</script>


<style scoped>
  .table-margin {
    margin-top: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/components/admin/ResourcesSchedule.vue